import { CUSTOM_STAGES } from './stage';

export const APP_COLORS = {
	GREY: '#A9A9A9',
	ORANGE: '#C2410C',
	GREEN: '#4CB782',
	YELLOW: '#F2C94C',
	RED: '#EB5757',
	WHITE: '#FEFEFE',
	PURPLE: '#584cf2',
	CYAN: '#4cf0f2',
	PINK: '#fba7f4',
};

export const STAGE_COLORS = {
	[CUSTOM_STAGES.ARCHIVED?.toLowerCase()]: APP_COLORS.GREY,
	[CUSTOM_STAGES.SHORTLISTED?.toLowerCase()]: APP_COLORS.GREEN,
	[CUSTOM_STAGES.NEW?.toLowerCase()]: APP_COLORS.YELLOW,
	other: APP_COLORS.WHITE,
};

export const LIGHT_APP_COLORS = Object.values(APP_COLORS).filter(
	(c) => ![APP_COLORS.GREY, APP_COLORS.RED, APP_COLORS.ORANGE, APP_COLORS.WHITE].includes(c)
);
